/**
 * Using a dot-separated key, where the dots represent levels of the object to traverse,
 * return the value from the obj specified by the key.
 * @param obj
 * @param key
 */
function getField(obj, key) {
    var firstKeySegment = key.split('.', 1)[0];
    var value = obj[firstKeySegment];
    if (value === undefined) {
        return value;
    }
    var remainingKey = key.slice(firstKeySegment.length + 1);
    if (remainingKey.length > 1) {
        return getField(value, remainingKey);
    }
    return value;
}
export { getField };
